import { createAsyncThunk } from "@reduxjs/toolkit";
import { getCurrentAssetBalanceApi } from "../../../apiservice/reports";

export const fetchCurrentAssetBalance = createAsyncThunk(
  "currentAssetBalance/fetch",
  async (filters, { rejectWithValue }) => {
    try {
      const res = await getCurrentAssetBalanceApi(filters);
      return {
        list: res.data?.assets || [],
        total_balance: res.data?.total_balance || 0,
      };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
